import { USER_DRAWN_POLYGON } from 'constants/actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_DRAWN_POLYGON:
      return action.geometry || initialState;
    default:
      return state;
  }
};
